import { createApp } from "vue";
import "./styles"; // 导入统一样式
import {
  setupAppVersionNotification,
  setupDayjs,
  setupIconifyOffline,
  setupLoading,
  setupNProgress,
  setupUI,
} from "./plugins";
import { setupRouter } from "@/router";
import { setupStore } from "@/store";
import { setupI18n } from './locales';
import App from "./App.vue";

// 创建Vue应用实例
const app = createApp(App);

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error("[Global Error]", err);
  console.error("Component:", instance);
  console.error("Error Info:", info);
};

// 调整为异步初始化流程
async function bootstrap() {
  // 第一阶段：基础工具初始化
  setupDayjs();          // 日期库应最先初始化
  setupIconifyOffline(); // 图标库初始化
  setupLoading();        // 加载状态管理
  setupNProgress();      // 进度条组件

  console.log("[Bootstrap] Starting application bootstrap");

  // 添加全局启动超时保护
  const globalTimeout = setTimeout(() => {
    console.error(
      "[Bootstrap] Application bootstrap timed out after 15 seconds"
    );
    // 强制挂载应用，即使路由没有完全准备好
    if (!app._container) {
      console.log("[Bootstrap] Forcing application mount due to timeout");
      app.mount("#app");
    }
  }, 15000);

  try {
    // 第二阶段：核心功能初始化
    console.log("[Bootstrap] Setting up Store");
    setupStore(app);     // 状态存储应尽早初始化
    
    console.log("[Bootstrap] Setting up i18n");
    setupI18n(app);      // 国际化在路由之前
    
    // 第三阶段：UI相关配置
    console.log("[Bootstrap] Setting up Element Plus");
    setupUI(app);        // UI框架在路由之前
    
    // 第四阶段：路由初始化
    console.log("[Bootstrap] Initializing router");
    await setupRouter(app); // 路由最后初始化
    
    // 第五阶段：辅助功能
    setupAppVersionNotification();

    // 最后挂载应用
    console.log("[Bootstrap] Mounting application");
    app.mount("#app");

    console.log("[Bootstrap] Application successfully mounted");
  } catch (err) {
    console.error("[Bootstrap] Application bootstrap error:", err);
    // 即使出错也尝试挂载应用
    if (!app._container) {
      console.log("[Bootstrap] Mounting application despite error");
      app.mount("#app");
    }
  } finally {
    clearTimeout(globalTimeout);
  }
}

// 启动引导
bootstrap().catch((err) => {
  console.error("[Bootstrap] Unhandled bootstrap error:", err);
  // 确保应用被挂载，即使出现未处理的错误
  if (!app._container) {
    app.mount("#app");
  }
});
